import React from "react";

function getLocation() {
  if (!navigator.geolocation) {
    Promise.reject(new Error("Geolocation is not supported in this browser"));
  } else {
    // status.textContent = 'Locating…';
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        position => {
          resolve(position);
        },
        error => {
          reject(error);
        }
      );
    });
  }
}

export function usePosition() {
  // console.log("userada");
  const [position, setPosition] = React.useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    getLocation()
      .then(position => {
        setPosition(position);
      })
      .catch(error => {
        setError(error);
      });
  }, []);

  return { position, error };
}
